import { isFixedEstimate, isSurfaceTravel, JourneyDataType } from "../@types/travel";

  export const collectActivityMetadata = (journey: JourneyDataType[] | []) => {
    // Number of stages ('n')
    const numberOfStages = journey.length
    if (!numberOfStages) {
      return null;
    }

    // Origin = Stage 1 origin
    const origin = extractOriginDestination(journey[0]).origin;
    const lastDestination = extractOriginDestination(journey[numberOfStages-1]).destination;

    // Destination = Stage n destination, unless the same as Stage 1 origin (i.e. a ‘return trip’), in which case choose Stage 1 destination)
    const destination = lastDestination === origin
      ? extractOriginDestination(journey[0]).origin
      : lastDestination;

    const transportMethods = Object.keys(Array.from(journey).reduce((acc,el) => ({...acc, [el.transportMethod]: 1}), {}));
    const method = transportMethods.length === 1 ? transportMethods[0] : 'MIXED';

    // Total distance travelled km’s (if easily available)
    const allDistancesHaveSameUnits = journey.every(j => j.distance?.unit?.toLocaleLowerCase() === journey[0].distance?.unit?.toLocaleLowerCase());
    const totalDistance = allDistancesHaveSameUnits
      ? { unit: journey[0].distance?.unit, value: journey.map(j => j.distance?.value).reduce((a,b) => a+b, 0) }
      : null;
    return {
      numberOfStages, origin, destination, method, totalDistance
    };

  };

  const extractOriginDestination = (journey: JourneyDataType): {origin: string | null; destination: string | null} => {
    if (isSurfaceTravel(journey)) {
      if (journey.activityMetadata?.travels?.length) {
        return {
          origin: journey.activityMetadata.travels[0].origin,
          destination: journey.activityMetadata.travels[journey.activityMetadata.travels.length-1].destination
        };
      }
    } else if (isFixedEstimate(journey)) {
      // no extractable information, fallback to default
    } else {
      if (journey.flights?.length) {
          const origin = journey.flights[0].origin;
          const lastDestination = journey.flights[journey.flights.length-1].destination;
          const destination = lastDestination === origin ? journey.flights[0].destination : lastDestination;
        return { origin, destination }
      }
    }
    return { origin: null, destination: null };
  }
